import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';


import funderbeam from '../../Pictures/funderbeam.png';
import crunchbase from '../../Pictures/crunchbase.png';
import craft from '../../Pictures/craft.png';


export class ChapterHundredFifteen extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">

        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {"" }
        </Subtopic>

        <a href="https://craft.co">
        <div className="block-outer block-outer-picholder">
          <div className="block-inner block-inner-picholder">
            <div className="pic-and-note-holder">
            <div className="pic-holder">
              <img alt="craft-logo" src={ craft } />
            </div>
            </div>
          </div>
        </div>
        </a>




          <TextHolder text="Craft is a machine-learning powered data and analytics platform building the “Source of Truth” on companies and mapping the global economy. The Company organizes financial, operating and human capital data from thousands of sources to provide comprehensive, up-to-date sector and company profiles, ranging from early-stage to the largest companies in the world. To learn more, visit https://craft.co."/>

          <a href="https://www.crunchbase.com">
          <div className="block-outer block-outer-picholder">
            <div className="block-inner block-inner-picholder">
              <div className="pic-and-note-holder">
              <div className="pic-holder">
                <img alt="crunchbase-logo" src={ crunchbase } />
                </div>
                </div>
              </div>
            </div>
          </a>


          <TextHolder text="Crunchbase is the destination for discovering industry trends, investments, and news about hundreds of thousands of public and private companies globally. From startups to Fortune 500s, Crunchbase provides a business information platform that pairs powerful tools and applications to stay competitive and successful. To learn more, visit www.crunchbase.com."/>

          <a href="https://www.funderbeam.com">
          <div className="block-outer block-outer-picholder">
            <div className="block-inner block-inner-picholder">
              <div className="pic-and-note-holder">
              <div className="pic-holder">
              <img alt="funderbeam-logo" src={ funderbeam } />
              </div>
              </div>
            </div>
          </div>
          </a>



          <TextHolder text="Funderbeam provides a user-friendly platform which allows almost anyone to become an investor and fund growing companies as well as trade their investments on a 24/7 marketplace—Thus, enabling growth capital to be easier to deliver and access than ever before possible. Utilising technology, strategic partnerships, and legal expertise to open cross-border investing and trading without irrelevant intermediaries, Funderbeam is the global marketplace for growth capital in a post-IPO world. On Blockchain. To learn more, visit www.funderbeam.com."/>
          <TextHolder text="" />

          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/115.js